import React from 'react';
import {
  Row,
  Col,
  Dropdown,
  Menu,
} from 'antd';
import PropTypes from 'prop-types';
import { PlusOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

import OnTraccrButton from '../../common/buttons/OnTraccrButton';
import { isClosedOrHistoricalBucket } from './BoardCardABWorkReportingHelpers';

const shouldBucketBeDisabled = (statuses) => (bidItem) => (
  isClosedOrHistoricalBucket(bidItem, statuses)
);

export default function BoardCardABWorkReportingHeader({
  onCreateWorkReport,
  selectedItem,
  selectedSegment,
  selectedBidItemKeys,
  onSettingsClick,
}) {
  const statuses = useSelector((state) => state.statuses.statuses);

  const selectedItemDisabled = selectedItem?.bidItems?.some(shouldBucketBeDisabled(statuses));
  const selectedSegmentDisabled = selectedSegment?.bidItems?.some(shouldBucketBeDisabled(statuses));

  const bidItems = selectedItem?.bidItems || selectedSegment?.bidItems || [];
  const bidItemSet = new Set(selectedBidItemKeys);
  const selectedBidItems = bidItems.filter((bidItem) => bidItemSet.has(bidItem.id));
  const selectedBidItemsDisabled = selectedBidItems?.some(shouldBucketBeDisabled(statuses));

  return (
    <Row justify="space-between" style={{ marginTop: 10, marginBottom: 10 }}>
      <Col span={16} style={{ fontSize: 24, fontWeight: 600 }}>
        Reporting
      </Col>
      <Col>
        <Dropdown
          overlay={(
            <Menu onClick={onCreateWorkReport}>
              <Menu.Item
                key="item"
                disabled={!selectedItem || !selectedItem.bidItems?.length || selectedItemDisabled}
              >
                Create Work Report for All Bid Items of Selected Item
              </Menu.Item>
              <Menu.Item
                key="segment"
                disabled={!selectedSegment || !selectedSegment.bidItems?.length || selectedSegmentDisabled}
              >
                Create Work Report for All Bid Items of Selected Segment
              </Menu.Item>
              <Menu.Item
                key="bidItems"
                disabled={!selectedBidItemKeys?.length || selectedBidItemsDisabled}
              >
                Create Work Report for Selected Bid Items
              </Menu.Item>
            </Menu>
          )}
        >
          <OnTraccrButton
            title="Create Work Report"
            icon={<PlusOutlined />}
          />
        </Dropdown>
        <OnTraccrButton title="Settings" style={{ marginLeft: 10 }} onClick={onSettingsClick} />
      </Col>
    </Row>
  );
}

BoardCardABWorkReportingHeader.propTypes = {
  onCreateWorkReport: PropTypes.func.isRequired,
  selectedItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    bidItems: PropTypes.array.isRequired,
  }),
  selectedSegment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    bidItems: PropTypes.array.isRequired,
  }),
  selectedBidItemKeys: PropTypes.arrayOf(PropTypes.string),
  onSettingsClick: PropTypes.func.isRequired,
};

BoardCardABWorkReportingHeader.defaultProps = {
  selectedItem: null,
  selectedSegment: null,
  selectedBidItemKeys: [],
};
